export default __webpack_public_path__ + "static/icon-dff852afb182d637420e6b3364014f4e.png";